<div class="container p-4">
	<div class="text-center"><h1>Troubleshooting Steps</h1></div>

	<div class="text-muted pb-3">Luna Fulfillment is more secure than ever, but if you are having trouble logging in to the Portal, try these options.</div>

	<ol class="fs-6">
		<li>
			<b>Try an incognito tab.</b><br />
			Incognito windows will have none of your usual cookies and cached information. This way you can test if the login will work with no saved browser data. If that works, continue to the next step:
		</li>

		<li>
			<b>Clear your cache and cookies.</b><br />
			Closing your browser and opening it again <i>will not</i> clear the data. You must do it manually, but you will only have to do this once.<br />
			In Chrome, navigate to More (the three dots) > Delete Browsing Data. Be sure to delete cookies &amp; other site data <i>and</i> cached images &amp; files.<br />
			In Safari, navigate to Settings > Privacy > Manage Website Data.<br />
			In Edge, navigate to Settings > Privacy, search, and services, then choose "Clear browsing data" and select "Choose what to clear." Check the boxes for "Cookies and other site data" and "Cached images and files" (and any other data types you wish to clear), choose a time range (like "All time"), and click "Clear now."
		</li>

		<li>
			<b>Do not use the Login with SSO button.</b> <br />
			SSO only works with approved partners. For now, try using your usual username and password to log in to the Portal.
		</li>

		<li>
			<b>Still experiencing issues?</b> <br />
			Our support team is available for you! Contact us at <span style="display: inline-block; font-weight: bold;"><a href="tel:1-800-801-0101">1-800-801-0101</a></span> to get one-on-one help.
		</li>

	</ol>

	<div class="d-flex justify-content-end">
		<button type="button" class="btn-close" aria-label="Close" (click)="close()"></button>
	</div>

</div>
